import { z } from 'zod';

export const inviteMemberFormSchema = z.object({
  email: z.email('Enter a valid email address'),
  role: z.enum(['ADMIN', 'MEMBER']),
});

export type InviteMemberFormValues = z.infer<typeof inviteMemberFormSchema>;
